// extracted by mini-css-extract-plugin
export default {"container":"styles_container__MgiL7","label":"styles_label__azv4x","checkbox":"styles_checkbox__TD6EN"};